import React, { ChangeEvent } from "react";
import styles from "./input-2026.module.scss";

export interface Input2026Props {
  id?: string;
  label: string;
  placeholder?: string;
  value: string | number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  type?: string;
}
const cssClassName = "input-2026";
export const Input2026 = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  type = "text",
}: Input2026Props) => {
  return (
    <div className={styles[`${cssClassName}`]}>
      <label htmlFor={id} className={styles[`${cssClassName}__label`]}>
        {label}
      </label>
      <input
        type={type}
        name={id}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={styles[`${cssClassName}__input`]}
      />
    </div>
  );
};
